export const SET_MEETING = "@meeting/setMeeting"
export const SET_PRESENT_PARTICIPANTS = "@meeting/setPresentParticipants"
export const REMOVE_MEETING_PARTICIPANT = "@meeting/removeMeetingParticipant"
export const SET_PRESENT_HOST_ID = "@meeting/setPresentHostId"
export const FETCH_MEETING = "@meeting/fetchMeeting"
export const RESET = "@meeting/reset"
export const POST_HOTSPOT_ANALYTICS = "@meeting/postHotspotAnalytics"